function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOWolontariatSecond = function SvgOWolontariatSecond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.1 101.28c0-30.03 22.39-52.04 53.19-52.04s53.18 22 53.18 52.04-23.72 52.04-53.18 52.04S.1 131.51.1 101.28m53.19 30.23c16.26 0 28.89-11.67 28.89-30.23S69.55 71.05 53.29 71.05 24.4 83.48 24.4 101.28s12.63 30.23 28.89 30.23",
    style: {
      fill: "#ff7900"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgOWolontariatSecond;